import React from "react";

import Styles from "./viewBeneficiaryModal.module.css";

// redux
import { useSelector, useDispatch } from "react-redux";
import {
  setViewBeneficiaryModalData,
  setViewBeneficiaryModalOpen
} from "../redux/slices/viewBeneficiaryModalSlice";

// components
import WenbitModal from "../../../../components/Modal/Modal";
import CoinDisplay from "../../../../components/CoinDisplay/CoinDisplay";

function ViewBeneficiaryModal() {
  const dispatch = useDispatch()
  const modalOpen = useSelector((state) => state.viewBeneficiaryModalState.open)
  const currencies = useSelector((state) => state.currencies.value)
  const beneficiary = useSelector((state) => state.beneficiary.value)

  const handleClose = () => {
    dispatch(
      setViewBeneficiaryModalData({
        callback: () => { }
      })
    )
    dispatch(setViewBeneficiaryModalOpen(false))
  }

  const isFiat = beneficiary?.currency_type === "fiat"

  // Format date to more readable format
  const formatDate = (dateString) => {
    if (!dateString) return "";
    const date = new Date(dateString);
    return date.toLocaleDateString() + ", " + date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
  };

  return (
    <>
      <WenbitModal
        open={modalOpen}
        showCloseButton={true}
        onClose={handleClose}
        title="Beneficiary Details"
        render={() => (
          <div className={Styles.modalBodyContainer}>
            <div className={Styles.detailsContainer}>
              {/* Currency information */}
              <CoinDisplay
                coinName={
                  <span style={{ fontWeight: 500 }}>
                    {currencies.find((el) => el.id === beneficiary.currency)?.name ||
                      beneficiary.currency?.toUpperCase()}
                  </span>
                }
                coinImgURL={
                  currencies.find((el) => el.id === beneficiary.currency)?.icon_url
                }
              />

              {/* General Information Section */}
              <div className={Styles.rowsContainer}>

                <div>
                  <span>Beneficiary ID</span>
                  <span>{beneficiary.uid}</span>
                </div>
                <div>
                  <span>Currency</span>
                  <span>{beneficiary.currency?.toUpperCase()}</span>
                </div>
                <div>
                  <span>Type</span>
                  <span>{isFiat ? "Fiat" : "Cryptocurrency"}</span>
                </div>
                <div>
                  <span>Reference Name</span>
                  <span>{beneficiary.name}</span>
                </div>
                {beneficiary.description && (
                  <div>
                    <span>Description</span>
                    <span>{beneficiary.description}</span>
                  </div>
                )}
                <div>
                  <span>Status</span>
                  <span>{beneficiary.state}</span>
                </div>
              </div>

              {/* Ownership/Approval Information */}
              <div>
                <div className={Styles.sectionTitle}>Creation & Approval</div>
                <div className={Styles.rowsContainer}>
                  <div>
                    <span>Created By</span>
                    <span>{beneficiary.request_by}</span>
                  </div>
                  <div>
                    <span>Created At</span>
                    <span>{formatDate(beneficiary.sent_at)}</span>
                  </div>
                  {beneficiary.payment_method_id && (
                    <div>
                      <span>Payment Method ID</span>
                      <span>{beneficiary.payment_method_id}</span>
                    </div>
                  )}
                </div>
              </div>

              {/* Fiat specific fields */}
              {isFiat && (
                <div>
                  <div className={Styles.sectionTitle}>Bank Details</div>
                  <div className={Styles.rowsContainer}>
                    <div>
                      <span>Bank Name</span>
                      <span>{beneficiary.data?.bank_name}</span>
                    </div>
                    <div>
                      <span>Account Holder</span>
                      <span>{beneficiary.data?.acc_holder_full_name}</span>
                    </div>
                    <div>
                      <span>Bank Code/IBAN</span>
                      <span>{beneficiary.data?.bank_code}</span>
                    </div>
                    {beneficiary.data?.account_number && (
                      <div>
                        <span>Account Number</span>
                        <span>{beneficiary.data.account_number}</span>
                      </div>
                    )}
                    <div>
                      <span>SWIFT/BIC</span>
                      <span>{beneficiary.data?.swift_bic}</span>
                    </div>
                    {beneficiary.data?.sort_code && (
                      <div>
                        <span>Sort Code</span>
                        <span>{beneficiary.data.sort_code}</span>
                      </div>
                    )}
                    <div>
                      <span>Bank Address</span>
                      <span>{beneficiary.data?.bank_address}</span>
                    </div>
                    <div>
                      <span>Bank Country</span>
                      <span>{beneficiary.data?.bank_country}</span>
                    </div>
                  </div>
                </div>
              )}

              {/* Crypto specific fields */}
              {!isFiat && (
                <div>
                  <div className={Styles.sectionTitle}>Wallet Details</div>
                  <div className={Styles.rowsContainer}>
                    <div>
                      <span>Wallet Address</span>
                      <span>{beneficiary.data?.address}</span>
                    </div>
                    {beneficiary.network && (
                      <div>
                        <span>Network</span>
                        <span>{beneficiary.network}</span>
                      </div>
                    )}
                    {beneficiary.data?.relation && (
                      <div>
                        <span>Relation</span>
                        <span>{beneficiary.data.relation}</span>
                      </div>
                    )}
                  </div>
                </div>
              )}
            </div>
          </div>
        )}
      />
    </>
  )
}

export default ViewBeneficiaryModal
